import { AppliedBillableConceptResponse, BillingCopaymentTypeEnumResponse, SumPerAccountingUnitResponse } from '@/api/services/billing/applied-billable-concept/billing-applied-billable-concept.dto'
import { BillableConceptResponse } from '@/api/services/billing/common-billable-concept/billing-common-billable-concept.dto'
import { BillableRateWithConceptInformationResponse } from '@/api/services/billing/common-billable-rate/billing-common-billable-rate.dto'
import { CustomerResponse } from '@/api/services/billing/common-customer/billing-common-customer.dto'
import { ValuableConceptsTreeNode } from '@/components/valuable-concepts-modal/valuable-concepts-modal-tree/valuable-concepts-modal-tree.model'
import { StrictNullable } from '@/shared/types/app.types'

export interface ValuableConceptsModalGridBasicFormInfo {
    caseId: StrictNullable<number>
    accountingUnit: StrictNullable<SumPerAccountingUnitResponse>
    rowSelected: StrictNullable<AppliedBillableConceptResponse>
    nodeSelected: StrictNullable<ValuableConceptsTreeNode>
    isBillingModule: StrictNullable<boolean>
}

export interface ValuableConceptsModalGridBasicFormCombo<T>{
    selected: StrictNullable<T>
    list: T[]
}

export interface ValuableConceptsModalGridBasicFormState {
    info: ValuableConceptsModalGridBasicFormInfo
    selectedConcept: StrictNullable<BillableConceptResponse>
    customers: ValuableConceptsModalGridBasicFormCombo<CustomerResponse>
    rates: ValuableConceptsModalGridBasicFormCombo<BillableRateWithConceptInformationResponse>
    error: boolean
    reasonError: StrictNullable<string>
    notToAddToInvoice: boolean
    reasonIfNotToAddToInvoice: StrictNullable<string>
    originalBillableValue: StrictNullable<number>
    billableValue: StrictNullable<number>
    autoInvoice: boolean
    authorizationCode: StrictNullable<string>
    hasCopayments: boolean
    isCopayment: boolean
    copaymentType: StrictNullable<BillingCopaymentTypeEnumResponse>
}
export const initialValuableConceptsModalGridBasicFormState =
    (): ValuableConceptsModalGridBasicFormState => ({
        info: {
            isBillingModule: null,
            caseId: null,
            accountingUnit: null,
            rowSelected: null,
            nodeSelected: null
        },
        selectedConcept: null,
        customers: {
            selected: null,
            list: []
        },
        rates: {
            selected: null,
            list: []
        },
        billableValue: null,
        originalBillableValue: 0,
        notToAddToInvoice: false,
        reasonIfNotToAddToInvoice: '',
        error: false,
        reasonError: '',
        autoInvoice: false,
        authorizationCode: null,
        hasCopayments: false,
        isCopayment: false,
        copaymentType: null
    })
